module.exports = __webpack_public_path__ + "img/imgbind.a7cf1c19.png";